// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import { useEffect } from "react"
import { BrowserRouter } from "react-router-dom"
import { I18nProvider } from "@/i18n"
import { AuthProvider } from "@/components/auth/AuthProvider"
import { ScrollManager } from "@/components/ScrollManager"
import { ConsentBanner } from "@/components/ConsentBanner"
import { RouteTracker } from "@/components/RouteTracker"
import { AnalyticsIdentity } from "@/components/auth/AnalyticsIdentity"
import { initAnalytics } from "@/lib/analytics"
import AppRoutes from "./routes"

export default function App() {
  // G04: wires the consent listeners once at app start. Actually loading
  // PostHog / the Meta Pixel stays deferred until ConsentBanner records the
  // matching opt-in — see lib/analytics.ts.
  useEffect(() => initAnalytics(), [])

  return (
    <I18nProvider>
      <BrowserRouter>
        <ScrollManager />
        <RouteTracker />
        <AuthProvider>
          <AnalyticsIdentity />
          <AppRoutes />
        </AuthProvider>
        <ConsentBanner />
      </BrowserRouter>
    </I18nProvider>
  )
}
